import { RelevanceType } from "types";
import styles from "./style.module.scss";
import classNames from "classnames";
import { useEnrichmentCardContext } from "../../pages/DataPage/CardsView/DataList/EnrichmentCard/EnrichmentCardProvider";

const RelevanceTypeIcon = ({ type }: { type: RelevanceType }) => {
  const { isSingleItem } = useEnrichmentCardContext();
  const containerClassnames = classNames(styles.container, {
    [styles.h]: type === "High",
    [styles.m]: type === "Medium",
    [styles.l]: type === "Low",
    [styles.small]: !isSingleItem,
  });

  return (
    <div className={containerClassnames}>
      <span className={styles.text}>{type}</span>
    </div>
  );
};

export default RelevanceTypeIcon;
